import React, { useState } from 'react';
import { useTranslation } from 'react-i18next';

import './BetslipPopup.scss';
import { useDispatch } from 'react-redux';

interface BetslipPopupCodeProps {
  placeFunction: Function
}

export default function BetslipPopupCode({ placeFunction } : BetslipPopupCodeProps) {
  const { t } = useTranslation();
  const [betCode, setBetode] = useState('');
  const dispatch = useDispatch();

  const onRegister = async (e) => {
    e.preventDefault();
    await dispatch.betslip.bookBet(betCode);
    placeFunction();
  };

  const handlePlaceBet = (e) => {
    e.preventDefault();
    dispatch.betslip.placeBookedBet(betCode);
    placeFunction();
  };

  return (
    <div className="betslip-popup__content">
      <div className="betslip-popup__container">
        <label className="betslip-popup__label">{ t('betslip.registered') }</label>
        <input
          className="betslip-popup__input"
          onChange={ (e) => setBetode(e.target.value) }
          value={ betCode }
          type="text"
          placeholder={ t('betslip.betCode') }
        />
      </div>
      <div className="betslip-popup__buttons betslip-popup__buttons--full-width">
        <div className="betslip-popup__btn betslip-popup__btn--full-width" onClick={ onRegister }>{ t('betslip.addToBetslip') }</div>
        <div
          className="betslip-popup__btn betslip-popup__btn--full-width betslip-popup__btn--secondary"
          onClick={ handlePlaceBet }
        >{ t('betslip.placeBet') }</div>
      </div>
    </div>
  );
}
